import { Component, EventEmitter, Input, Output , OnInit, OnChanges} from '@angular/core';
import { AuthenticationService } from '../../../providers/authentication/authentication.service';
import { Router } from '@angular/router';
import { ServiciosStatsProvider } from '../../../providers/web-service-service/servicios-stats';

const CACHE_DESF_SEC = 120;
const BUSCACONTENIDO = 2;

@Component({
  selector: 'app-contenidosdash',
  templateUrl: './contenidosDash.component.html',
  styleUrls: ['./contenidosDash.component.scss']
})
export class ContenidosDashComponent implements OnInit, OnChanges {
	@Input() contenidosIndicadores: any;
	@Input() contenidosIndicadoresFavoritos: any;

	@Input() listaContenidos: any[] = [];
	todosContenidosFiltrados: any[] = [];
	tipoContenido: string = 'masVisitados';
	@Input() listaContenidosFavoritos:  {
		lista: undefined[],
		msg: '',
		res: 0
	};
    constructor(public authService: AuthenticationService,public router: Router,public statsService: ServiciosStatsProvider,
        ){

    }

    ngOnInit(){
		this.listaContenidos = [];
		this.listaContenidosFavoritos = {
			lista: undefined,
			msg: '',
			res: 0
		};

        const hoy = new Date();
        const inicio = new Date(hoy.getFullYear(), hoy.getMonth(), 1, hoy.getHours(), hoy.getMinutes());
        const fin = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0, hoy.getHours(), hoy.getMinutes());

        this.cargarIndicadoresContenidos({
            inicio: inicio,
            fin: fin
        });
    }
    ngOnChanges(change){
		let contenidosFiltradosFavoritos = [];

		let _favoritos = {
			lista: [],
			msg: '',
			res: 0
		};
		 _favoritos.lista = this.listaContenidosFavoritos.lista;
		this.contenidosIndicadoresFavoritos = {};
		this.contenidosIndicadoresFavoritos.total = _favoritos.lista.length;
		let _n = 0;
		contenidosFiltradosFavoritos = _favoritos.lista
		contenidosFiltradosFavoritos.forEach(element => {
			element.percent = element.USUARIOS.length;
			element.num = _n + 1;
			element.class = '';
			if ( _n === 0){
				element.class = 'lineaPrimera';
			}
			_n++;
		});
		this.contenidosIndicadoresFavoritos.lista = contenidosFiltradosFavoritos;
	}
    navegarContenidos(_contenido){
		// console.log(_contenido.Id);
		this.router.navigate(['/contenidos/editar', { id: _contenido.Id, entidad: 'CONTENIDO' }]);
		//https://espaciosjunta.juntadeandalucia.es/#/contenidos/editar;id=0eea6e42-2867-ed11-88b8-0050568999a2;entidad=CONTENIDO
		//this.router.navigate(['/contenidos/editar'], { queryParams: { titulo: _contenido.Titulo }});
	}
	hayContenidosFavoritos(): boolean{
		if(this.contenidosIndicadoresFavoritos && this.contenidosIndicadoresFavoritos.lista && this.contenidosIndicadoresFavoritos.lista.length === 0){
			return true;
		}
		else {
			return false;
		}
	}
    hayContenidos(): boolean{
		if(this.contenidosIndicadores && this.contenidosIndicadores.lista && this.contenidosIndicadores.lista.length === 0){
			return true;
		}
		else {
			return false;
		}
	}
    onChangeRangeContents(dateRange){
		this.cargarIndicadoresContenidos(dateRange);

	}

    calculaTimeCache(){
		const fec = new Date();
		const timestamp = fec.getTime() - (fec.getTime() % (CACHE_DESF_SEC * 1000));


		return timestamp;
	}
    cargarIndicadoresContenidos(dateRange){
		console.log(dateRange);
		const _contenidos = this.listaContenidos;

		if (!_contenidos){
			return;
		}

		this.contenidosIndicadores = {};
		this.contenidosIndicadores.total = _contenidos.length;



		const ahora = new Date();
		const idEspacio = this.authService.getIdEspacio();
		const token = this.authService.getToken();
		const that = this;
        
		const timeCache = this.calculaTimeCache();


		const horaFin = ahora.getHours() * 100 + ahora.getMinutes();
		let horaIni = horaFin;

		const fInicio = this.statsService.fechaToCubefec(dateRange.inicio);
		const fFin = this.statsService.fechaToCubefec(dateRange.fin) ;
		const rangoF = fInicio.fecha + ',' + fFin.fecha;

		let group = 'Contenido_id';
		if (dateRange.lastMinutes != null){
			group += ',Hora';
			horaIni -= dateRange.lastMinutes;

		}

		const filtroContenido = {
			Group: group,
			RangeFecha: rangoF,
			Espacio: idEspacio,
			cache: 'CUBEDASHCONT_D_' + idEspacio + rangoF + timeCache,
			tipo: BUSCACONTENIDO,
			Order: 'Total DESC',
		};

		const todosContenidosById = {};
		_contenidos.forEach(element => {
			todosContenidosById[element.Id] = element;
		});

		// console.log(todosContenidosById);

		this.statsService.statsVisitaCuenta(token, filtroContenido, function (res) {
			if (!res.lista){
				return;
			}
			// console.log(res);
			const total = res.lista.length;
			let max = 7;
			const contenidosFiltrados = [];
			that.todosContenidosFiltrados = [];
			let COUNT = 0;
			for ( const i in res.lista){
				if (! res.lista[i] || ! res.lista[i].Contenido){
					continue;
				}
				const _contenido = todosContenidosById[res.lista[i].Contenido];
				if (!_contenido){
					continue;
				}

				if (dateRange.lastMinutes != null){
					const _hora = parseInt(res.lista[i].Hora, 0);
					if (!(horaIni <= _hora && _hora <= horaFin)){
						continue;
					}
				}
				// console.log(res.lista[i]);

				_contenido.Total = res.lista[i].Total;
				COUNT += _contenido.Total ;

				// console.log(_contenido);

				max--;
				if ( max >= 0){
					contenidosFiltrados.push(_contenido);
				}
				that.todosContenidosFiltrados.push(res.lista[i]);
			}
			// console.log(contenidosFiltrados);

			let _n = 0;
			contenidosFiltrados.forEach(element => {
				element.percent = Math.floor(element.Total * 10000 / COUNT) / 100;
				element.num = _n + 1;
				element.class = '';
				if ( _n === 0){
					element.class = 'lineaPrimera';
				}
				_n++;
			});

			that.contenidosIndicadores.lista = contenidosFiltrados;

		});

	}
}


// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/graficas/contenidosDash/contenidosDash.component.ts